// extracted by mini-css-extract-plugin
export var discard = "_47-3";
export var muiTooltipTooltip = "_47-5";
export var notificationBar = "_47-2";
export var saveButtonHoverSlotWrapper = "_47-4";
export var show = "_47-1";
export var spacer = "_47-0";